import React from 'react';
import OrderCodesItem from "./CurrentOrderCodesItem";
import { useTranslation } from "react-i18next";

interface CurrentOrderCodesListProps {
    userOrderData: any;
}

const CurrentOrderCodesList = (props: CurrentOrderCodesListProps) => {
  const { t } = useTranslation();
  
  return (
    <div className="currentOrderCodes__container">
      {
        props.userOrderData && props.userOrderData.length > 0 &&
        props.userOrderData.filter((item: any) => item && !item.isConfirmed && !item.isReserved && !item.isDeclined).length > 0 && (
          <div className="currentOrderCodes__container_content pending">
            <div className="currentOrderCodes__container_content_category">
              <span>{t('main.pending')}</span>
            </div>
            <div className="currentOrderCodes__container_content_data">
              <div className="currentOrderCodes__container_content_data_items">
                {
                  props.userOrderData &&
                  props.userOrderData.length > 0 &&
                  props.userOrderData.filter((item: any) => item && !item.isConfirmed && !item.isReserved && !item.isDeclined).length > 0 &&
                  props.userOrderData.filter((item: any) => item && !item.isConfirmed && !item.isReserved && !item.isDeclined).map((item: any, index: number) => {
                    return (
                      <OrderCodesItem
                        key={index}
                        item={item}
                        isDineIn={item.dineInAdId}
                      />
                    )
                  })
                }
              </div>
            </div>
          </div>
        )
      }
      
      {
        props.userOrderData && props.userOrderData.length > 0 &&
        props.userOrderData.filter((item: any) => item && (item.isConfirmed || item.isReserved)).length > 0 && (
          <div className="currentOrderCodes__container_content">
            <div className="currentOrderCodes__container_content_category">
              <span>{t('main.confirmed')}</span>
            </div>
            <div className="currentOrderCodes__container_content_data">
              <div className="currentOrderCodes__container_content_data_items">
                {
                  props.userOrderData.filter((item: any) => item && (item.isConfirmed || item.isReserved)).map((item: any, index: number) => {
                    return (
                      <OrderCodesItem
                        key={index}
                        item={item}
                        isDineIn={item && item.dineInAdId!}
                      />
                    )
                  })
                }
              </div>
            </div>
          </div>
        )
      }
      
      {
        props.userOrderData && props.userOrderData.length > 0 &&
        props.userOrderData.filter((item: any) => item && item.isDeclined).length > 0 && (
          <div className="currentOrderCodes__container_content">
            <div className="currentOrderCodes__container_content_category">
              <span>{t('main.declined')}</span>
            </div>
            <div className="currentOrderCodes__container_content_data">
              <div className="currentOrderCodes__container_content_data_items">
                {
                  props.userOrderData.filter((item: any) => item && item.isDeclined).map((item: any, index: number) => {
                    return (
                      <OrderCodesItem
                        key={index}
                        item={item}
                        isDineIn={item && item.dineInAdId!}
                      />
                    )
                  })
                }
              </div>
            </div>
          </div>
        )
      }
    </div>
  );
};

export default CurrentOrderCodesList;